export interface ContactFormValues {
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  messageContent: string;
  confirmedForm: boolean;
}
